"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/Message/Preview.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _broadcastCampaign = require('shared/validation/broadcastCampaign');
var _secureText = require('shared/constants/secureText');
var _broadcastTemplate = require('shared/services/broadcastTemplate');
var _broadcastTemplateTokens = require('shared/services/broadcastTemplateTokens');
var _peers = require('shared/selectors/peers');
var _org = require('shared/selectors/org');
var _team = require('shared/selectors/team');
var _phone = require('shared/services/phone');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _hooks = require('web/services/hooks');
var _format = require('web/screens/Broadcast/format');

var _Spinner = require('web/components/Spinner');
var _SmsPreview = require('web/components/SmsPreview');
var _SimpleSelect = require('web/components/Form/SimpleSelect'); var _SimpleSelect2 = _interopRequireDefault(_SimpleSelect);


const DEFAULT_SHOWN = 8
const MAX_PROBLEMS_SHOWN = 20
const MAX_SEARCH_RESULTS = 50














const patientName = (patients, key) => {
  const p = patients[key]
  return p ? [p.FirstName, p.LastName].filter(Boolean).join(' ') || p.Name || 'Unnamed patient' : 'Unknown patient'
}

const initialsOf = (name) => name
  .split(/\s+/)
  .filter(Boolean)
  .slice(0, 2)
  .map(p => _optionalChain([p, 'access', _ => _[0], 'optionalAccess', _2 => _2.toUpperCase, 'call', _3 => _3()]))
  .join('')

const blank = (v) => !v || !v.trim()

 const buildPreviewRows = (draft, recipients) => {
  const tokens = _broadcastTemplateTokens.templateTokens.call(void 0, draft.MessageTemplate)
  return recipients.messages.map(message => {
    const name = patientName(recipients.patients, message.PatientKey)
    // Rev 24 M1: first_name and last_name come from the patient record.
    const patient = recipients.patients[message.PatientKey]
    const valueOf = (variable) => {
      if (!_broadcastTemplate.BUILT_IN_TEMPLATE_VARIABLES.some(b => b.Name === variable)) return _optionalChain([message, 'access', _4 => _4.TemplateData, 'optionalAccess', _5 => _5[variable]])
      return variable === 'first_name' ? _optionalChain([patient, 'optionalAccess', _6 => _6.FirstName]) : _optionalChain([patient, 'optionalAccess', _7 => _7.LastName])
    }
    const check = _broadcastTemplate.checkRecipientRender.call(void 0, draft, message.TemplateData, patient)
    const hasDefault = (variable) => !blank(_optionalChain([draft, 'access', _8 => _8.TemplateFields, 'access', _9 => _9.find, 'call', _10 => _10(f => f.Name === variable), 'optionalAccess', _11 => _11.Default]))
    const defaulted = [...new Set(tokens
      .filter(t => blank(valueOf(t.name)) && (t.fallback !== null || hasDefault(t.name)) && !check.unresolved.includes(t.name))
      .map(t => t.name))]
    return {
      message,
      name,
      initials: initialsOf(name),
      check,
      usesFallback: tokens.some(t => t.fallback !== null && blank(valueOf(t.name))),
      defaulted,
    }
  })
}; exports.buildPreviewRows = buildPreviewRows

/* M4: recipients whose message can't send first, then the first few; a name
 * search reaches every loaded recipient. */
 const visibleRows = (rows, query) => {
  const q = query.trim().toLowerCase()
  if (q) return rows.filter(r => r.name.toLowerCase().includes(q)).slice(0, MAX_SEARCH_RESULTS)
  const problems = rows.filter(r => !r.check.ok).slice(0, MAX_PROBLEMS_SHOWN)
  const others = rows.filter(r => r.check.ok).slice(0, Math.max(3, DEFAULT_SHOWN - problems.length))
  return [...problems, ...others]
}; exports.visibleRows = visibleRows

/* Rev 35 E1: one line about the recipient shown, and a short reason in the
 * Preview as option of one who needs attention. */
const rowStatus = (r) => {
  const [missing, ...moreMissing] = r.check.unresolved
  if (missing) {
    const names = moreMissing.length ? `${missing} and ${_format.pluralize.call(void 0, moreMissing.length, 'more', 'more')}` : missing
    return { tone: 'warn', text: `No value for ${names}, and no default` }
  }
  if (r.check.length > r.check.limit) return { tone: 'warn', text: `Over the ${_format.formatCount.call(void 0, r.check.limit)} limit` }
  if (r.defaulted.length) return { tone: 'warn', text: `Uses the default for ${r.defaulted.join(', ')}` }
  return { tone: 'ok', text: 'All values present.' }
}

const optionReason = (r) => {
  if (r.check.unresolved.length) return `no ${r.check.unresolved.join(', ')}`
  if (r.check.length > r.check.limit) return 'over the limit'
  return null
}

/* The rendered text, with any token that stayed unresolved marked. */
const RenderedBody = ({ check }) => {
  if (!check.unresolved.length) return _react2.default.createElement(_react2.default.Fragment, null,  check.rendered )
  const unresolved = new Set(check.unresolved)
  const parts = []
  let last = 0
  _broadcastTemplateTokens.templateTokens.call(void 0, check.rendered).forEach((t, i) => {
    if (!unresolved.has(t.name)) return
    parts.push(check.rendered.slice(last, t.index))
    parts.push(_react2.default.createElement('mark', { key: i, className: "broadcast-preview--unresolved", __self: this, __source: {fileName: _jsxFileName, lineNumber: 118}},  t.text ))
    last = t.index + t.text.length
  })
  parts.push(check.rendered.slice(last))
  return _react2.default.createElement(_react2.default.Fragment, null,  parts )
}









/* Rev 35 E1: the preview half of the Message | Preview toggle, the same in the
 * Edit message dialog and the wizard's Message step. One recipient at a time:
 * Preview as (those needing attention first, then the first few) with ‹ ›,
 * one status line, then what their phone shows. */
const Preview = ({ campaign, template, recipients, notice = null }) => {
  const [selectedKey, setSelectedKey] = _react.useState(null)

  const draft = _react.useMemo.call(void 0, 
    () => ({ ...campaign, MessageTemplate: template }),
    [campaign, template],
  )
  const rows = _react.useMemo.call(void 0, 
    () => recipients ? exports.buildPreviewRows.call(void 0, draft, recipients) : [],
    [draft, recipients],
  )
  const shown = _react.useMemo.call(void 0, () => exports.visibleRows.call(void 0, rows, ''), [rows])
  const selected = _nullishCoalesce(_nullishCoalesce(shown.find(r => r.message.PatientKey === selectedKey), () => ( shown[0])), () => ( null))
  const index = selected ? shown.indexOf(selected) : -1
  const attention = shown.filter(r => !r.check.ok).length

  const senderName = _hooks.useAppSelector.call(void 0, state => _nullishCoalesce(_optionalChain([_peers.selectUserByKey.call(void 0, state, campaign.SenderKey), 'optionalAccess', _12 => _12.Name]), () => ( '')))
  const orgName = _hooks.useAppSelector.call(void 0, state => _nullishCoalesce(_optionalChain([_org.selectOrgByKey.call(void 0, campaign.OrgKey, state), 'optionalAccess', _13 => _13.Name]), () => ( '')))
  const teamPhone = _hooks.useAppSelector.call(void 0, state => _nullishCoalesce(_optionalChain([_team.selectTeamByKey.call(void 0, state, campaign.TeamKey), 'optionalAccess', _14 => _14.PhoneNumber]), () => ( '')))

  const body = () => {
    if (!template.trim()) return _react2.default.createElement('p', { className: "broadcast-wizard--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 158}}, "Write a message to preview it."     )
    if (!recipients) return _react2.default.createElement('div', { className: "broadcast-preview--loading", __self: this, __source: {fileName: _jsxFileName, lineNumber: 159}}, _react2.default.createElement(_Spinner.SimpleSpinner, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 159}} ))
    if (!selected) {
      return (
        _react2.default.createElement('p', { className: "broadcast-wizard--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 162}}, "Add recipients to see the message as each of them would receive it."

        )
      )
    }
    const status = rowStatus(selected)
    const step = (by) => setSelectedKey(shown[index + by].message.PatientKey)
    return (
      _react2.default.createElement(_react2.default.Fragment, null
        , _react2.default.createElement('div', { className: "broadcast-preview--as", __self: this, __source: {fileName: _jsxFileName, lineNumber: 171}}
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 172}}, "Preview as" )
          , _react2.default.createElement(_SimpleSelect2.default, {
            'aria-label': "Preview as" ,
            value: selected.message.PatientKey,
            onChange: key => setSelectedKey(key ),
            options: shown.map(r => {
              const reason = optionReason(r)
              return { value: r.message.PatientKey, label: reason ? `${r.name} · ${reason}` : r.name }
            }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 173}}
          )
          , _react2.default.createElement('button', {
            type: "button",
            className: "broadcast-preview--step",
            'aria-label': "Previous recipient" ,
            disabled: index <= 0,
            onClick: () => step(-1), __self: this, __source: {fileName: _jsxFileName, lineNumber: 182}}
, "‹"

          )
          , _react2.default.createElement('button', {
            type: "button",
            className: "broadcast-preview--step",
            'aria-label': "Next recipient" ,
            disabled: index >= shown.length - 1,
            onClick: () => step(1), __self: this, __source: {fileName: _jsxFileName, lineNumber: 191}}
, "›"

          )
          , _react2.default.createElement('span', { className: "broadcast-preview--position", __self: this, __source: {fileName: _jsxFileName, lineNumber: 200}}
            ,  `${_format.formatCount.call(void 0, index + 1)} of ${_format.formatCount.call(void 0, shown.length)} shown` 
            ,  attention > 0 && ` · ${_format.pluralize.call(void 0, attention, 'needs', 'need')} attention, listed first` 
          )
        )
        , _react2.default.createElement('p', { className: _classBuilder2.default.call(void 0, 'broadcast-preview--status', status.tone === 'warn' && 'broadcast-preview--status--warn'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 205}}
          ,  status.tone === 'warn' && _react2.default.createElement('span', { 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 206}}, "! " ) ,  status.text 
        )
        , _react2.default.createElement('div', { className: "broadcast-preview--well", __self: this, __source: {fileName: _jsxFileName, lineNumber: 208}}
          ,  campaign.MessageType === _broadcastCampaign.MessageType.InsecureSMS
            ? _react2.default.createElement(SmsPreview, { check: selected.check, teamPhone: teamPhone, __self: this, __source: {fileName: _jsxFileName, lineNumber: 210}} )
            : _react2.default.createElement(SecurePreview, { check: selected.check, senderName: senderName, orgName: orgName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 211}} )
          
        )
      )
    )
  }

  return (
    _react2.default.createElement('div', { className: "broadcast-preview", __self: this, __source: {fileName: _jsxFileName, lineNumber: 219}}
      ,  notice 
      ,  body() 
    )
  )
}

const LengthMeta = ({ check }) => (
  _react2.default.createElement('div', { className: "broadcast-preview--meta", __self: this, __source: {fileName: _jsxFileName, lineNumber: 227}}
    , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 228}},  _format.formatCount.call(void 0, check.length) , " characters" )
    , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 229}}
      ,  check.length > check.limit ? 'over' : 'within' , " the "  ,  _format.formatCount.call(void 0, check.limit) , " limit"
    )
  )
)

const SmsPreview = ({ check, teamPhone }) => (
  _react2.default.createElement('div', { className: "broadcast-preview--sms", __self: this, __source: {fileName: _jsxFileName, lineNumber: 236}}
    , _react2.default.createElement('div', { className: "broadcast-preview--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 237}}, _react2.default.createElement('span', { className: "broadcast-preview--num", __self: this, __source: {fileName: _jsxFileName, lineNumber: 237}}, "1"), " On their phone"   )
    , _react2.default.createElement(_SmsPreview.SmsPhone, { from: teamPhone ? `Text message from ${_phone.formatPhoneNumber.call(void 0, teamPhone)}` : 'Text message', __self: this, __source: {fileName: _jsxFileName, lineNumber: 238}}
      , _react2.default.createElement(_SmsPreview.SmsBubble, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 239}}, _react2.default.createElement(RenderedBody, { check: check, __self: this, __source: {fileName: _jsxFileName, lineNumber: 239}} ))
      , _react2.default.createElement(LengthMeta, { check: check, __self: this, __source: {fileName: _jsxFileName, lineNumber: 240}} )
    )
    , _react2.default.createElement('p', { className: "broadcast-preview--caption", __self: this, __source: {fileName: _jsxFileName, lineNumber: 242}}, "Sent as an "
         ,  _secureText.INSECURE_TEXT_LABEL.toLowerCase() , ". " ,  _secureText.CANT_CONTAIN_PHI , "."
    )
  )
)

const SecurePreview



 = ({ check, senderName, orgName }) => {
  const from = [senderName, orgName].filter(Boolean).join(' from ') || 'Your care team'
  return (
    _react2.default.createElement('div', { className: "broadcast-preview--secure", __self: this, __source: {fileName: _jsxFileName, lineNumber: 255}}
      , _react2.default.createElement('div', { className: "broadcast-preview--secure-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 256}}
        , _react2.default.createElement('div', { className: "broadcast-preview--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 257}}
          , _react2.default.createElement('span', { className: "broadcast-preview--num", __self: this, __source: {fileName: _jsxFileName, lineNumber: 258}}, "1"), " Text message"
        )
        , _react2.default.createElement(_SmsPreview.SmsPhone, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 260}}
          , _react2.default.createElement(_SmsPreview.SmsBubble, { className: "broadcast-preview--notification", __self: this, __source: {fileName: _jsxFileName, lineNumber: 261}}
            , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 262}},  from ), " just sent you a secure message. Click the link to read it:"            , ' '
            , _react2.default.createElement('span', { className: "broadcast-preview--link", __self: this, __source: {fileName: _jsxFileName, lineNumber: 263}}, "https://blm.care/…")
          )
        )
        , _react2.default.createElement('p', { className: "broadcast-preview--caption", __self: this, __source: {fileName: _jsxFileName, lineNumber: 266}}, "The same for everyone. Your message isn't in it."        )
      )
      , _react2.default.createElement('span', { className: "broadcast-preview--arrow", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 268}}, "→")
      , _react2.default.createElement('div', { className: "broadcast-preview--secure-page", __self: this, __source: {fileName: _jsxFileName, lineNumber: 269}}
        , _react2.default.createElement('div', { className: "broadcast-preview--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 270}}
          , _react2.default.createElement('span', { className: "broadcast-preview--num", __self: this, __source: {fileName: _jsxFileName, lineNumber: 271}}, "2"), " Secure page, after they tap"
        )
        , _react2.default.createElement('div', { className: "broadcast-preview--page", __self: this, __source: {fileName: _jsxFileName, lineNumber: 273}}
          , _react2.default.createElement('div', { className: "broadcast-preview--page-bar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 274}}, _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 274}}, "blm.care"))
          , _react2.default.createElement('div', { className: "broadcast-preview--page-head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 275}}, "From: " , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 275}},  orgName || 'your organization' ))
          , _react2.default.createElement('div', { className: "broadcast-preview--page-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 276}}
            , _react2.default.createElement(_SmsPreview.SmsBubble, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 277}}, _react2.default.createElement(RenderedBody, { check: check, __self: this, __source: {fileName: _jsxFileName, lineNumber: 277}} ))
            , _react2.default.createElement(LengthMeta, { check: check, __self: this, __source: {fileName: _jsxFileName, lineNumber: 278}} )
          )
        )
      )
    )
  )
}

exports. default = Preview
